<script setup lang="ts">
/*
 *
 * Imports
 *
 * */

//PrimeVue
import { default as PButton } from 'primevue/button'
import { default as PSelect } from 'primevue/select'

//Vue, router
import { computed, type ModelRef } from 'vue'
import { useRouter } from 'vue-router'

//Custom components and types
import type { ReferentialDomain } from '@/core/domain/referential/domain/ReferentialDomain.ts'
import { useLearningModulesStore } from '@/presentation/stores/learning/learningModules.ts'
import type { LearningModuleInput } from '@/core/domain/learning/module/LearningModule.ts'

//Utils
const router = useRouter()
const modelModule: ModelRef<LearningModuleInput> = defineModel('module', { required: true })
const learningModuleStore = useLearningModulesStore()

const props = defineProps<{
  fieldToUpdate: string | null
  domain: ReferentialDomain
  learningCourseId: number
  isCreating: boolean
}>()

const taskOptions = computed(() => {
  return props.domain.tasks.map((task) => ({
    label: task.title,
    value: task.id
  }))
})

const taskLabel = computed(() => {
  const label = taskOptions.value.find((task) => task.value === modelModule.value.taskId)?.label
  return label ? label : 'Aucune tâche ne correspond'
})

async function validateUpdate() {
  if (props.isCreating) {
    modelModule.value = (
      await learningModuleStore.createModule(modelModule.value, props.learningCourseId)
    ).createLearningModuleInput()
  }
}
</script>

<template>
  <div class="w-full">
    <h5 class="text-color font-bold">Tâche liée (référentiel Paideia)</h5>
    <p-select
      v-if="isCreating"
      v-model="modelModule.taskId"
      :options="taskOptions"
      option-label="label"
      option-value="value"
      class="mt-4 w-full"
      placeholder="Choisissez une tâche dans la liste"
    />
    <template v-else>
      <span class="p-text-secondary">
        {{ taskLabel }}
      </span>
    </template>
  </div>

  <div class="mt-4 flex w-full gap-4" v-if="isCreating">
    <p-button
      label="Annuler"
      @click="
        router.push({ name: 'learning-course-update', params: { courseId: learningCourseId } })
      "
      severity="secondary"
      size="small"
    />
    <p-button
      label="Enregistrer"
      @click="validateUpdate()"
      severity="primary"
      size="small"
      :disabled="!modelModule.taskId || !fieldToUpdate === null"
    />
  </div>
</template>
